{
  "name": "app",
  "version": "1.9.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "npm run start -- --live-reload=false",
    "build": "ng build",
    "build:local": "npm run build -- --configuration=local",
    "build:dev": "npm run build -- --configuration=development",
    "build:staging": "npm run build -- --configuration=staging && npm run translate:optimize",
    "build:prod": "npm run build -- --configuration=production && npm run translate:optimize",
    "lint": "ng lint",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "translate:optimize": "transloco-optimize dist/app/browser/assets/locales"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/router": "^21.1.5",
    "@jsverse/transloco": "^8.2.1",
    "@jsverse/transloco-messageformat": "^8.2.1",
    "@jsverse/transloco-optimize": "^8.2.1",
    "@tinymce/tinymce-angular": "^9.1.1",
    "@touch4it/ng-swp": "^10.0.1",
    "date-fns": "^4.1.0",
    "lodash-es": "^4.17.21",
    "ng-zorro-antd": "^21.1.0",
    "ngx-device-detector": "^11.0.0",
    "rxjs": "~7.8.0",
    "ts-node": "^10.9.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.1.5",
    "@angular/cli": "^21.1.5",
    "@angular/compiler-cli": "^21.1.5",
    "@touch4it/ng_eslint_rulezz": "~1.7.0",
    "@types/lodash-es": "^4.17.12",
    "less": "^4.2.0",
    "typescript": "~5.9.3"
  }
}
